"use client";
import CWFResponsiveSheet from "@/components/ui/CWFResponsiveSheet";
import {useState} from "react";
import {Button} from "@/components/ui/button";
import {FaClock, FaEuroSign} from "react-icons/fa";
import ReservationPanel from "@/components/Reservation/ReservationPanel";
import {SheetClose} from "@/components/ui/sheet";

export default function OfferDetail({offer, userIsLoggedIn, profile, userId}) {
    const [sheetOpen, setSheetOpen] = useState(false);

    return(
        <>
            <div
                className={"absolute h-48 bg-gradient-to-b from-transparent to-white flex flex-col justify-end items-start pb-5 w-full  bottom-0"}>
                <div className={"pl-2"}>
                    <button className={"uppercase underline font-medium"} onClick={() => setSheetOpen(true)}>Voir plus</button>
                </div>

            </div>
            <CWFResponsiveSheet
                className={"w-full md:w-3/4 overflow-y-scroll"}
                title={offer.title}
                trigger={null}
                onOpenChange={setSheetOpen}
                open={sheetOpen}
                footer={(
                    <div className={"flex justify-between items-center w-full pt-5"}>
                        <p className={"flex gap-x-1 items-center"}><FaEuroSign/> {offer.price}</p>
                        <ReservationPanel offer={offer} userIsLoggedIn={userIsLoggedIn} userId={userId} profile={profile}/>
                    </div>
                )}
            >
                <img src={offer.document?.path || '/imagedefault.png'} className="w-full h-1/2 md:h-1/3 object-contain aspect-square"/>
                <p className={"whitespace-pre-line pt-2"}>{offer.description}</p>
                {offer.week_number ?
                    <p className={"font-semibold"}><span className={"font-normal"}>Nombre de semaine : </span> {offer.week_number}</p>
                    : null
                }

            </CWFResponsiveSheet>
        </>
    )
}